module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CN",
    attrs: {
      "id": "_idParaDest-15",
      "xml:lang": "en-GB"
    }
  }, [_vm._v("6")]), _vm._v(" "), _c('p', {
    staticClass: "CT-1line",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    staticClass: "CharOverride-21"
  }, [_vm._v("Nhan Dan")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-CO"
  }, [_c('span', {
    staticClass: "Cap _idGenCharOverride-1"
  }, [_vm._v("S")]), _c('span', {
    staticClass: "SmallCaps"
  }, [_vm._v("ome")]), _c('span', {
    staticClass: "SmallCaps"
  }, [_c('span', {
    staticClass: "lead-in _idGenCharOverride-2"
  }, [_vm._v(" ACTIVISTS IN ")])]), _vm._v("the States "), _c('a', {
    attrs: {
      "id": "_idTextAnchor124"
    }
  }), _vm._v("romanticized Ho Chi Minh and his cause, emphasizing its nationalist character and seeing a common enemy in LBJ, but the president and the hawks were right about one thing: Hanoi was Communist and authoritarian to its core. It was not about to become a satellite state to either the Soviet Union or, least of all, China. Instead, the reunified nation imagined by the Vietnam Workers Party"), _c('a', {
    attrs: {
      "id": "_idTextAnchor125"
    }
  }), _c('span', {
    attrs: {
      "href": "#/eBook_V455773#_idTextAnchor1084",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("65")])]), _vm._v(" was modeled on the Soviet state and deeply influenced by Mao’s ongoing Cultural Revolution. It was ruthless and doctrinaire. It promised a state-run economy and a society ruled by the party, where allegiance to the regime was absolute.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("No nation is immune to wishful thinking. By its own implacable logic, the party was "), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("nhan dan")]), _vm._v(", the people, so what the party dictated was by definition the will of the people. It also believed its own propaganda. When the plans for the Tet Offensive were drawn up, it meant the attack on Hue and those throughout South Vietnam would be an expression of the people’s will, so it was only natural to believe that the people would rise up to support it. Westy’s ramrod optimism paled next to the party’s. Led by First Secretary Le Duan, over the objections of more realistic politburo members, Hanoi had convinced itself that victory was within its grasp.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The plan called for attacks leading up to Tet against American bases throughout the South—Khe Sanh, Da Nang, Con Tien, Pleiku, and others. It anticipated that Westy would move his troops to defend his own bases, which would leave Saigon, Hue, Can Tho, Nha Trang, and dozens of other South Vietnamese cities to be defended by much weaker ARVN forces. The combined NVA and VC army would be more than a match for most urban defenses. "), _c('a', {
    attrs: {
      "id": "_idTextAnchor126"
    }
  }), _vm._v("But the logistics, secretly moving the Front forces into place, were daunting, and in some cases, at least initially, poorly thought out. When the great military strategist who had chased the French from Vietnam fourteen years earlier, General Vo Nguyen Giap, was dispatched to outline the plan to VC commanders in March 1967, he proposed establishing a center for the push into Hue in the lowlands southwest of the city.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Dang Kinh, a local commander, told him: “You will all starve to death!”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("He explained that the people who lived in the area proposed were fishermen, and that they grew no rice. To feed an army, they would need a steady supply of rice.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Giap asked how much of Thua Thien Province (which included Hue) the proposed force would be able to take. Kinh responded facetiously, saying, in effect: "), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Why ask me? ")]), _vm._v("He pointed out that Hanoi liked to make such plans without consulting lowly field commanders.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m just a tool,” he told Giap. “Point me at a target and I’ll attack it. I’m not capable of answering your question, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Giap told the scrappy local commander that he was going to be given a full NVA regiment.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Sir, our military region cannot handle another regiment,” answered Kinh.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“You are a strange bird,” said Giap. “All of our battlefield commanders are asking for more units, but when the high command offers you another regiment you refuse to accept it.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I’m a guerrilla commander,” said Kinh. “If you give me too many troops, I will not be able to command all of them.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Since Hue had never been the scene of much fighting, it was rarely thought of in military terms. But considered as such, it had significant value. Vietnam is a long thin stretch of land, covering more than two thousand miles of coast along the Gulf of Tonkin and the South China Sea. It widened at the northern end, which bordered China, and fanned out again at the far southern end into the swampy lands of the Mekong delta, but at its center it narrowed as if cinched by a belt. It was so narrow in the Hue region that a drive from the beach to the mountainous Laotian border took"), _c('a', {
    attrs: {
      "id": "_idTextAnchor127"
    }
  }), _vm._v(" under an hour. Both Highway 1 and the nation’s primary rail line connecting the giant American base at Da Nang with the DMZ to the north passed through Hue. The Huong River was wide and deep enough for vessels to deliver a steady stream of supplies to forces north and south. Control of Hue was the key to these transportation routes. And yet the thrust of the plan to take the city was never primarily concerned with shutting down the river, the highway, and the rails. The thrust of the effort was political. The real battlefield, as far as the party was concerned, was "), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("nhan dan.")]), _vm._v(" If they could be induced to rally behind the Front’s forces, the war would be over.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Kinh never believed it would happen, but he was a good soldier, and if ordered to attack, he’d attack. In discussions with Giap over the following days, he agreed that the city could be taken and, if his forces were properly reinforced and positioned, it could be held for a few days. He estimated that even with ten thousand men, within days the ARVN and Americans could respond with seven times that many men, not to mention artillery, air support, tanks, etc. They could not long resist such an onslaught, and they would take heavy losses. As for the plans farther south, he told Giap that Hanoi was trying to stage a bonfire with barely enough fuel to burn a match. But the party leaders had an answer for that: with enough fuel, all you needed was a match. They expected the oppressed people of South Vietnam to rise up en masse"), _c('span', {
    staticClass: "CharOverride-2"
  }), _vm._v("once they saw the liberation army marching in their streets. The Thieu government would collapse! The Americans would have no choice but to go home."), _c('a', {
    attrs: {
      "id": "_idTextAnchor128"
    }
  }), _c('span', {
    attrs: {
      "href": "#/eBook_V455773#_idTextAnchor1085",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("66")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Hanoi’s leaders were virtuoso songbirds of propaganda. They lived in a bubble. There were no voices of dissent in their society to check or challenge wishful thinking. And they were certain of their ultimate victory. Years earlier the songbirds had argued that the war could be quickly ended before the American buildup, but that had not happened. Things had gotten worse in the south, not better. There was evidence of good feeling in rural areas, but the big cities showed no such signs. VC casualties had gone up alarmingly, recruitment was down, and desertion was becoming more common. So while no one outside the party’s cloisters dared question the big plan, some within did.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("There were basically two competing views "), _c('a', {
    attrs: {
      "id": "_idTextAnchor129"
    }
  }), _vm._v("about the war. One preached patience and caution, knowing that for all its firepower America could not sustain a long war and would eventually have to bargain and leave. This approach was advocated by China and endorsed by Ho himself, who was nothing if not patient after a lifetime of struggle. He was now a frail and sickly man of seventy-seven with only a year to live. He was spending more and more time at a clinic in China. He was there from mid-September to late December 1967, and after a brief visit to Hanoi returned to the clinic in early January to stay until late April 1968. He was out of the country for most of the planning and all the fighting of Tet. He had outlived not only his enemies in the party, but also much of his influence. He remained invaluable as Uncle Ho, the father of the nation. He was universally respected in the North, and revered by many in the South. The short poems attributed to him, read aloud on ceremonial occasions, were composed by committees for propaganda purposes, and they sounded like it, but they were also easy to remember and encapsulated the goals of the struggle. One went like this:")]), _vm._v(" "), _c('p', {
    staticClass: "Poetry-01"
  }, [_vm._v("Vi doc lap, vi tu do")]), _vm._v(" "), _c('p', {
    staticClass: "Poetry-02"
  }, [_vm._v("Danh cho My cut")]), _vm._v(" "), _c('p', {
    staticClass: "Poetry-02"
  }, [_vm._v("Danh chon Nguy nhao.")]), _vm._v(" "), _c('p', {
    staticClass: "Poetry-01"
  }, [_c('span', {
    staticClass: "CharOverride-17"
  }, [_vm._v("For our independence and freedom")])]), _vm._v(" "), _c('p', {
    staticClass: "Poetry-02"
  }, [_c('span', {
    staticClass: "CharOverride-17"
  }, [_vm._v("Let’s sweep the Americans out")])]), _vm._v(" "), _c('p', {
    staticClass: "Poetry-03"
  }, [_c('span', {
    staticClass: "CharOverride-17"
  }, [_vm._v("And make the ")]), _vm._v("Nguys"), _c('span', {
    staticClass: "CharOverride-17"
  }, [_vm._v(" fall down.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("His influence was substantial but soft. "), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Soft, ")]), _vm._v("in the sense that his legend and manner softened the party’s message. Ho was viewed as a nationalist first, only secondarily as a Communist. He had fully embraced party principles, for sure, but he was also known for his humility and benevolence. The party, on the other hand, was hard. Persuasion was not a priority; its critics and enemies were imprisoned or killed. Ho knew there were many in the South who opposed Hanoi not so much on ideological grounds, but because of its methods. They had seen the VC execute or imprison leaders who did not fall in line. Ho consistently preached to the party that victory and reunification required winning the support of their southern cousins. "), _c('a', {
    attrs: {
      "id": "_idTextAnchor130"
    }
  }), _vm._v("He believed the effort might take many years. It would probably not come in his lifetime.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("So for Ho, the point of war was to force the United States to negotiate. He took advantage of every opportunity to remind the Americans of his willingness to work with them. His speech declaring Vietnam’s freedom in 1945 had cribbed from the Declaration of Independence."), _c('a', {
    attrs: {
      "id": "_idTextAnchor131"
    }
  }), _c('span', {
    attrs: {
      "href": "#/eBook_V455773#_idTextAnchor1086",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("6")]), _c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("7")])]), _vm._v(" He offered to begin negotiations for peace anytime, and even to invite the Americans over for tea, but at the same time he warned that he would prevail even if it took “twenty years.”"), _c('span', {
    attrs: {
      "href": "#/eBook_V455773#_idTextAnchor1088",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "id": "_idTextAnchor132"
    }
  }), _c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("68")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Younger party leaders were in a bigger hurry. A faction headed by Le Duan advocated not just forcing the Americans to negotiate an end to the war, but also "), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("winning")]), _vm._v(" the war. It was determined to seize the initiative. The politburo argued out war plans for the coming year in the summer of 1967. The foreign minister, Nguyen Duy Trinh, predicted some kind of major American offensive before the Americans’ election day in November 1968—perhaps even an invasion of the North. Such a move might strengthen Johnson’s hand enough to dictate a quick end to the war on his own terms. Le Duan argued, “We must elevate our own military activities to a new level, to a level that the United States cannot bear and that will force it to accept that it has failed militarily and that it has become isolated politically. If we can accomplish that, the United States will be forced to withdraw from Vietnam.”"), _c('a', {
    attrs: {
      "id": "_idTextAnchor133"
    }
  }), _c('span', {
    attrs: {
      "href": "#/eBook_V455773#_idTextAnchor1089",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("69")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Turning up the heat was appealing in part because of the growing antiwar movement in the United States. The politburo did not expect LBJ to capitulate, but an escalation of the war could undermine his hopes for reelection. Militarily, the Americans were already a potent fighting force, and they knew that Westy, for all his talk about turning over war fighting to the ARVN, was continuing to build up his own command: he had requested hundreds of thousands of new soldiers in 1967, and had been granted an additional forty-seven thousand in July. The American threat was only going to grow, so waiting carried big risks. Acting first, delivering a decisive blow, might give Hanoi a critical advantage."), _c('a', {
    attrs: {
      "id": "_idTextAnchor134"
    }
  }), _c('span', {
    attrs: {
      "href": "#/eBook_V455773#_idTextAnchor1090",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("70")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“As long as we have not won such a victory, we cannot achieve success at the conference table,” Trinh said."), _c('a', {
    attrs: {
      "id": "_idTextAnchor135"
    }
  }), _c('span', {
    attrs: {
      "href": "#/eBook_V455773#_idTextAnchor1091",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("71")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“Victory” was defined as inflicting “heavy casualties” on American forces, the destruction of the ARVN, and inciting a general uprising throughout the South. "), _c('a', {
    attrs: {
      "id": "_idTextAnchor136"
    }
  }), _vm._v("The more realistic, like Ho, knew that all this was unlikely, but Le Duan believed complete success wasn’t necessary. He wrote, “If for some reason the uprisings in the cities run into trouble and we are forced to pull our forces out, that will not matter. That will just be an opportunity for us to practice and to learn lessons from experience in order to prepare to try again at a later date. Comrade Fidel Castro’s armed forces attacked the cities three times before they finally succeeded. If we enter the cities but then are forced to withdraw, that is nothing to be afraid of, because the entire rural countryside and the mountain jungles all belong to us—our position and our forces are strong in those areas.”"), _c('a', {
    attrs: {
      "id": "_idTextAnchor137"
    }
  }), _c('span', {
    attrs: {
      "href": "#/eBook_V455773#_idTextAnchor1092",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("72")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Ho remained unenthusiastic. His opinion was echoed by the Chinese, who pointed to the protracted nature of Mao’s struggle. They saw the planned Tet campaign as a nod to Soviet tactics, and, in effect, a sign that the party was leaning more toward Moscow than Beijing."), _c('a', {
    attrs: {
      "id": "_idTextAnchor138"
    }
  }), _c('span', {
    attrs: {
      "href": "#/eBook_V455773#_idTextAnchor1093",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("7")]), _c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("3")])]), _vm._v(" More significantly, the campaign was also opposed by Giap. Le Duan had bested the general in a power struggle for party leadership in 1957, and the two men had been at odds for years. But this was a nation ruled by commissars, not by generals: the guerrilla general Kinh’s sarcasm about the strategy was rooted in a truth Giap knew well. When the Party Central Committee adopted Resolution 13 in January 1967, calling for a “decisive victory” in advance of reopening talks with the United States, it meant Le Duan was still in charge.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Giap’s handle on the military was slipping, too. The death of Hanoi’s commanding general of southern operations in the summer of 1967 elevated General Van Tien Dung, who had long served as Giap’s subordinate. While still nominally less important than Giap in the chain of command, Dung began meeting directly with Le Duan to plan the Tet Offensive. Ambition for it grew. Together they decided, in the words of Vietnam War historian Merle L. Pribbenow, to “consider risking everything on one roll of the dice.”"), _c('a', {
    attrs: {
      "id": "_idTextAnchor139"
    }
  }), _c('span', {
    attrs: {
      "href": "#/eBook_V455773#_idTextAnchor1094",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("7")]), _c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("4")])]), _vm._v(" It called for an all-out attack on cities in South Vietnam while the NVA’s main forces worked to pin down American and ARVN troops in rural bases. The rest would be accomplished by the people.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Giap began skipping planning meetings, and made it clear he believed the strategy would not work. When the final plan for the offensive, Resolution 14, was approved by the politburo in December, the old general was out of the country. "), _c('a', {
    attrs: {
      "id": "_idTextAnchor140"
    }
  }), _vm._v("He was in Moscow on the eve of Tet, and attended a performance of the ballet "), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Swan Lake")]), _vm._v(". Giap did not wish to be seen attending the theater at the same time his troops were launching their daring attacks, so he waited until the house lights were turned down before entering."), _c('a', {
    attrs: {
      "id": "_idTextAnchor141"
    }
  }), _c('span', {
    attrs: {
      "href": "#/eBook_V455773#_idTextAnchor1095",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("7")]), _c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("5")])]), _vm._v(" Ho abstained from voting on final approval for the plan,"), _c('a', {
    attrs: {
      "id": "_idTextAnchor142"
    }
  }), _c('span', {
    attrs: {
      "href": "#/eBook_V455773#_idTextAnchor1096",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("7")]), _c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("6")])]), _vm._v(" although once it was clear it was going forward, he gave his endorsement before returning to China."), _c('a', {
    attrs: {
      "id": "_idTextAnchor143"
    }
  }), _c('span', {
    attrs: {
      "href": "#/eBook_V455773#_idTextAnchor1097",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("77")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Acting on instructions from Hanoi, the regional party committee for the Thua Thien–Hue district resolved on December 3 “to concentrate all of our strength and intellect on urgently carrying out preparations.” The offensive would be “a secret surprise attack against specific targets,” after which the people would “conduct uprisings to fight and support combat operations, and "), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("force a revolutionary government")]), _vm._v(".” A major goal would be to “inflict heavy losses on U.S. and satellite [allied] forces,” and “defeat the American ‘limited war’ strategy.”"), _c('a', {
    attrs: {
      "id": "_idTextAnchor144"
    }
  }), _c('span', {
    attrs: {
      "href": "#/eBook_V455773#_idTextAnchor1098",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("7")]), _c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("It was not until January 15 that the final decision was made to launch the offensive on the eve of Tet. According to Pribbenow, the party had begun purging military officers whose sympathies were with Giap."), _c('a', {
    attrs: {
      "id": "_idTextAnchor145"
    }
  }), _c('span', {
    attrs: {
      "href": "#/eBook_V455773#_idTextAnchor1099",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("7")]), _c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("9")])]), _vm._v(" All dissension was silenced. The songbirds took over. The cities would fall! The people would rise up! The war would end! As the song reached down to the rank and file, it spurred fanatical hope and zeal.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("To that end, hidden cadres of loyalists living in camps in the mountains west and south of Hue had been working and waiting, some of them for years. Most were young men and women accustomed to hardship and fired with idealism.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("For Nguyen Dac Xuan, a poet and Buddhist, the cause was mixed with his religious fervor."), _c('a', {
    attrs: {
      "id": "_idTextAnchor146"
    }
  }), _c('span', {
    attrs: {
      "href": "#/eBook_V455773#_idTextAnchor1100",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("80")])]), _vm._v(" He had fled the city in 1966 during President Thieu’s violent suppression of Buddhist protests. After hiding in temples to escape the secret police, he had been invited by a friend to take shelter in a VC camp hidden in the forested hills. Xuan had ended up living there, and while he still considered himself Buddhist—he was a follower of the Hue monk Thich Nhat Hanh, a peace activist who had fled to the United States—he was by no means committed to the religion’s traditional pacifism. What joy and sense of kinship and purpose he felt with his new comrades! They were both hardened and buoyed by privation, rationing rice balls while dreaming of feasts, sleeping huddled together against the cold, imagining a blissful communal future. They were not blind to the odds against them; they were "), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("inspired")]), _vm._v(" by these odds."), _c('a', {
    attrs: {
      "id": "_idTextAnchor147"
    }
  }), _vm._v(" They believed the very purity of their devotion guaranteed success. What could the Americans do to them? Their death, if it came, would be not a loss but a glorious sacrifice, like a drop of fuel for the great flame. Together they wrote poetry and memorized and dissected Ho’s inspirational verses. On a Roneo machine they produced a propaganda newspaper called "), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Liberation Flag")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("For all his zeal, Xuan had chafed under military discipline. With surveillance planes often overhead, it was important to avoid anything that might give away the camp. So when Xuan and his comrades decided to cut down a few trees to clear space for a crude newspaper office, they were chastised for creating a hole in the canopy of trees. There was a strict ban on lighting fires for fear of telltale smoke, but the nights were cold. Xuan was convinced that no smoke could escape the thick blanket of low clouds that smothered them in the rainy months like a wet blanket. After making a small experiment a good distance away from the camp, lighting a fire and noting how its smoke drifted off hugging the ground, he defiantly lit one at the newspaper office. This brought his immediate superior running in panic. Xuan told her about his experiment.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("“I don’t know any science, at all,” she told him, angrily. “But I do know the ban on fires is a rule none can disobey.”")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Xuan missed his home in Hue, and he and his friends would sometimes climb high in the trees to gaze down at it in the distance. He would point out his old neighborhood of Dap Da, and the university. Growing up and attending school he had never felt especially attached to the city, but in exile he yearned for it. So when he was first told of plans for Tong-Tan-cong-Noi-day, he was overjoyed.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The politburo decreed: “All South Vietnam will simultaneously launch a general offensive–general insurrection to seize the reins of government and place it in the hands of the people. Principle of the offensive: simultaneous attacks, simultaneous uprisings, with insurrections being the prime effort and relying primarily on local forces and forces in the rears.”"), _c('a', {
    attrs: {
      "id": "_idTextAnchor148"
    }
  }), _c('span', {
    attrs: {
      "href": "#/eBook_V455773#_idTextAnchor1101",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("8")]), _c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("According to Vietnam’s official history of the war, they were “to annihilate or disperse the puppet army and puppet government, to liberate the rural countryside, to form a revolutionary government, to kill and wound large numbers of "), _c('a', {
    attrs: {
      "id": "_idTextAnchor149"
    }
  }), _vm._v("American troops, and to surround and isolate the American forces so that they would be unable to come to the rescue of the puppet army . . . fight off enemy counterattacks, to inflict heavy losses on the enemy, and to firmly defend and protect the new revolutionary government in order to create favorable conditions to allow us to move forward to gaining total victory.”"), _c('a', {
    attrs: {
      "id": "_idTextAnchor150"
    }
  }), _c('span', {
    attrs: {
      "href": "#/eBook_V455773#_idTextAnchor1102",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("82")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Creating those “favorable conditions” meant weeding out their enemies. A great score settling was in store. They would target South Vietnamese officials, soldiers, and police—“thugs,” “traitors,” and “criminals” in official parlance. Presumably those insufficiently motivated to embrace the party’s vision would quickly see the wisdom of doing so. Hue was going to join the revolution, like it or not.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("For Xuan it also would be a homecoming. He and the others wrote and printed pamphlets to be distributed when they arrived. The handouts would explain the goals of the offensive, and emphasize that it was not a Northern invasion but a countrywide uprising. They explained the tripartite nature of the Alliance of National and Peace Forces; it was composed of intellectuals, religious leaders, and the VC cadres. The pamphlets also explained that success depended on "), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("them,")]), _vm._v(" on"), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(" nhan dan")]), _vm._v(". They were the future, casting out the past, ending foreign domination.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("With the new year would dawn a new, independent Vietnam.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Their excitement spilled out in a book of celebratory poems. Xuan went to sleep in those nights ticking off in his head which neighborhoods he would visit first, which traditional Hue dishes he would first eat, which houses of his family and friends he would first visit. He anticipated a great battle. Some had drawn up last wills. They vied to be chosen to lead the assault.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4484a6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eBook_V455714.vue
// module id = 105
// module chunks = 0